<template>
  <v-app>
    <!-- 読込中 -->
    <v-skeleton-loader
      v-show="progress"
      width="100%"
      max-height="300"
      type="card"
    ></v-skeleton-loader>

    <v-container class="pa-0" v-if="!progress && about != null">
      <v-container fluid class="pa-0">
        <v-row no-gutters v-for="item in about.law" :key="item.id">
          <v-col>
            <v-row no-gutters class="grey lighten-4">
              <v-col class="pl-4 pr-4 pt-2 pb-2"
                ><span class="text-body-1">{{ item.item }}</span></v-col
              >
            </v-row>
            <v-row no-gutters>
              <v-col class="pl-4 pr-4 pt-2 pb-4"
                ><span class="pre-wrap text-body-2" v-text="item.value"></span
              ></v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { liffReady } from "../util/liff_util";

export default {
  data: () => ({}),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "特定商取引法に基づく表記";
    this.$store.state.cart = false;
  },
  computed: {
    ...mapGetters(["progress", "about"]),
  },
  async mounted() {
    await liffReady(); // LIFF 初期化待機
    this.showProgress();

    try {
      await this.fetchData();
    } catch (e) {
      console.error(e);
    } finally {
      this.hideProgress();
    }
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress", "fetchAbout"]),
    fetchData: async function () {
      return this.fetchAbout();
    },
  },
};
</script>
<style>
@import "../css/common.css";
</style>